const READ_NOTIFICATIONS_KEY = "readNotifications";
const DELETED_NOTIFICATIONS_KEY = "deletedNotifications";


export const saveReadNotification = (notifyId) => {
  const current = JSON.parse(localStorage.getItem(READ_NOTIFICATIONS_KEY)) || [];
  if (!current.includes(notifyId)) {
    localStorage.setItem(READ_NOTIFICATIONS_KEY, JSON.stringify([...current, notifyId]));
  }
};

export const getReadNotifications = () => {
  return JSON.parse(localStorage.getItem(READ_NOTIFICATIONS_KEY)) || [];
};

export const saveAllReadNotifications = (notifyIds) => {
    const current = JSON.parse(localStorage.getItem(READ_NOTIFICATIONS_KEY)) || [];
      const updated = [...new Set([...current, ...notifyIds])];
  localStorage.setItem(READ_NOTIFICATIONS_KEY,JSON.stringify(updated));
};

export const clearReadNotifications = () => {
  localStorage.removeItem(READ_NOTIFICATIONS_KEY);
};


// إضافة
export const saveDeletedNotifications = (notifyIds) => {
  const current = JSON.parse(localStorage.getItem(DELETED_NOTIFICATIONS_KEY)) || [];
  const updated = [...new Set([...current, ...notifyIds])];
  localStorage.setItem(DELETED_NOTIFICATIONS_KEY, JSON.stringify(updated));
};

export const getDeletedNotifications = () => {
  return JSON.parse(localStorage.getItem(DELETED_NOTIFICATIONS_KEY)) || [];
};
